// extracted by mini-css-extract-plugin
export default {"scrollToTopDiv":"scrollToTop_scrollToTopDiv__mRO4u","scrollUpDown":"scrollToTop_scrollUpDown__j6LFj","arrowDiv":"scrollToTop_arrowDiv__kSzXk"};